import type { RollSpec } from "../islands/ui/roll_chip";

export const ROLLABLE = "[data-dice-bar-instruction-param]";

// A rollable is the server's HTML with `data-dice-bar-*-param` attributes (`MonsterContentComponent`, `dice-notation`); a click
// on one is read as the RollSpec those params describe.
export function statBlockSpec(target: { closest(selector: string): { dataset: DOMStringMap } | null }): RollSpec | null {
	const element = target.closest(ROLLABLE);
	const {
		diceBarInstructionParam: instruction,
		diceBarSuccessParam: success,
		diceBarAttackParam: attack,
		diceBarDescriptionParam: description,
	} = element?.dataset ?? {};
	return instruction ? { instruction, success, attack: attack === "true", description: description ?? "" } : null;
}

export const isActivation = (key: string) => key === "Enter" || key === " ";
